module.exports = __webpack_public_path__ + "static/media/profile.f7538c32.svg";